import { ON_LOGOUT } from 'core/constants';
import { runListenersForEvent } from 'core_main/globals/events';
import { importAndInitializePubNub } from 'core_main/globals/vendors';
import { clearUserDataFromStore } from 'core_main/store';
import { removeTrackingTokenFromLocalStorage } from 'helpers/browser';
import { init } from '../init';

export const logout = (cb) => {
  return importAndInitializePubNub().then((module) => {
    const pubnub = module;

    if (typeof pubnub === 'object') {
      try {
        pubnub.clearPubNub();
        clearUserDataFromStore();
        removeTrackingTokenFromLocalStorage();
        init({}, () => {
          if (typeof cb === 'function') cb();
          runListenersForEvent(ON_LOGOUT);
        });
      } catch (error) {
        if (typeof cb === 'function') cb(null, error);
        if (error instanceof Error) {
          runListenersForEvent(ON_LOGOUT, null, error);
        }
        console.error('Failed to logout', error);
      }
    }
  });
};
